import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import { API_AP_LOG_SEARCH, MAIN_URL, PORT } from "../../constants/constants";
import {
  CLEAR_DATA_LOGBOOK_ADMINISTRATIVE_PROCEDURES,
  SET_LOGBOOK_ADMINISTRATIVE_PROCEDURES_DATA,
  UPDATE_DATA_LOGBOOK_ADMINISTRATIVE_PROCEDURES,
} from "../types";

export function getDataLogbookAdministrativeProcedures(params) {
  return async (dispatch) => {
    try {
      let url = MAIN_URL + PORT + API_AP_LOG_SEARCH;

      url += `?dateStart=${params.dateStart}&dateEnd=${params.dateEnd}&size=1000`;

      const response = await fetchWithToken(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      });

      if (!response) {
        return;
      }

      const data = await response.json();

      dispatch({
        type: SET_LOGBOOK_ADMINISTRATIVE_PROCEDURES_DATA,
        data: data.content,
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };
}

export const updateDataLogbookAdministrativeProcedures = (data) => {
  return {
    type: UPDATE_DATA_LOGBOOK_ADMINISTRATIVE_PROCEDURES,
    data: data,
  };
};

export const clearDataLogbookAdministrativeProcedures = () => {
  return {
    type: CLEAR_DATA_LOGBOOK_ADMINISTRATIVE_PROCEDURES,
    data: [],
  };
};
